import { useQuery } from '@tanstack/react-query'
import { useApi } from '../api/contexto'
import type { ErrorApi } from '../api/errores'
import type { components } from '../api/modelos'
import { TAMANO_PAGINA } from '../componentes/paginacion'
import type { FiltrosAvisos } from './useFiltrosAvisos'

export type AvisoResumen = components['schemas']['AvisoResumen']
export type PaginaAvisos = components['schemas']['Pagina_AvisoResumen_']
export type ResumenAvisos = components['schemas']['ResumenAvisos']

/** 15 por página, como todos los listados (`componentes/paginacion.ts`). */
export function useAvisos(filtros: FiltrosAvisos, tamanoPagina: number = TAMANO_PAGINA) {
  const api = useApi()

  return useQuery<PaginaAvisos, ErrorApi>({
    // `filtros` entero en la clave: al cambiar de pagina o de filtro la clave
    // cambia y TanStack Query no puede servir el resultado anterior.
    queryKey: ['avisos', filtros, tamanoPagina],
    queryFn: ({ signal }) =>
      api.pedir<PaginaAvisos>('/api/avisos', {
        parametros: {
          estado: filtros.estado,
          semanas_minimas: filtros.semanas_minimas,
          // El buscador se llama `q` en la API; el cliente omite el vacio.
          q: filtros.q,
          page: filtros.page,
          page_size: tamanoPagina,
        },
        senal: signal,
      }),
  })
}

/**
 * Las metricas de cabecera, en su propia consulta. Aparte del listado a
 * proposito: describen la seccion entera y no cambian al filtrar ni al pasar de
 * pagina, asi que atarlas al listado las recargaria sin motivo y, peor, un
 * fallo de una se llevaria por delante a la otra.
 */
export function useResumenAvisos() {
  const api = useApi()

  return useQuery<ResumenAvisos, ErrorApi>({
    queryKey: ['avisos', 'resumen'],
    queryFn: ({ signal }) => api.pedir<ResumenAvisos>('/api/avisos/resumen', { senal: signal }),
  })
}
